export const formatPercent = (value: number) => {
    if (typeof value !== 'number') return value
    let formattedValue = '' + value.toFixed(2)
    if (formattedValue.includes('-')) {
        return `(${formattedValue.slice(1)}%)`
    }
    return formattedValue + '%'
}

export const formatNegative = (
    value: string,
    index?: number,
): string | null => {
    // Don't format "--" values or empty/null values as negative
    if (value?.startsWith('-') && value !== '--' && index !== 0) {
        return '(' + value.slice(1) + ')'
    }
    return value
}

export const calculatePercentage = (value: number, total: number): number =>
    total !== 0 ? (value / total) * 100 : 0

export const formatPercentage = (value: number): string =>
    value < 0 ? `(${Math.abs(value)}%)` : `${value}%`

export const formatNumber = (value: number): string =>
    value < 0 ? `(${Math.abs(value)})` : `${value}`
